import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import moment from 'moment';
import * as regData from '../../../../appConstants'

import ContainerHeader from '../../../components/ContainerHeader/index';

import * as addCustomer from '../../../actions/customerdetails';
import * as getCustomer from '../../../actions/customerdetails';

import CustomerRequest from '../../../api/requests/CustomerRequest'

class AddCustomer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setValue: false,
            id: this.props.params.id,
            customer: { id: '', customer_name: '', contact_name: '', email_id: '', customer_mb_no: '', street_name: '', po_box_no: '', city: '', country: '', login_id: '', remarks: '', mdm: '', logo: '', path: '', subcription_date: '' }
        };
        // console.log('this.state.customer', this.state.customer);
    }

    componentDidMount() {
        // console.log('componentDidMount')
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            this.props.actions.fetchCustomerDetails(this.state.id);
        }
        else
            this.state.customer = { id: '', customer_name: '', contact_name: '', email_id: '', customer_mb_no: '', street_name: '', po_box_no: '', city: '', country: '', login_id: '', remarks: '', mdm: '', logo: '', path: '', subcription_date: '' }
    }
    componentWillUnmount() {
        this.state.customer = { id: '', customer_name: '', contact_name: '', email_id: '', customer_mb_no: '', street_name: '', po_box_no: '', city: '', country: '', login_id: '', remarks: '', mdm: '', logo: '', path: '', subcription_date: '' };
    }
    handleChange(field, e) {
        // console.log('state',this.state);
        const customer = Object.assign({}, this.state.customer, { [field]: e.target.value });
        // console.log('customer',this.state);
        this.setState(Object.assign({}, this.state, { customer }));
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.actions.addCustomerDetails(this.state.customer);
    }

    render() {
        // console.log('render')
        const { match, getData, addCustomer, params, customer } = this.props;
        // console.log('addCustomer', addCustomer)
        // console.log('getData', getData)
        let result = null;
        if ((addCustomer && addCustomer.Status) || (getData && getData.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getData && getData.customerdetails && !this.state.setValue) {
            this.state.customer = getData.customerdetails;
            this.setState({ setValue : true });
        }
        return (
            <div className="slideInUpTiny">
                {result}
                <ContainerHeader title="Add Customer" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Add Customer</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="customer_name" label="Customer Name"
                                                validators={['required',regData.regexAlphaNumeric,regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                                value={this.state.customer.customer_name} onChange={this.handleChange.bind(this, 'customer_name')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="contact_name" label="Contact Person Name"
                                                validators={['required',regData.regexAlphaNumeric,regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                                value={this.state.customer.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="login_id" label="User Id"
                                                validators={['required',regData.regexUserName,regData.regexUserNameLength]}
                                                errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                                value={this.state.customer.login_id} onChange={this.handleChange.bind(this, 'login_id')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="email_id" label="Email Address"
                                                validators={['required', 'isEmail']} errorMessages={['This field is required', 'email is not valid']}
                                                value={this.state.customer.email_id} onChange={this.handleChange.bind(this, 'email_id')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="customer_mb_no" label="Mobile Number"
                                                validators={['required', 'isNumber']}
                                                errorMessages={['This field is required', 'Number is not valid']}
                                                value={this.state.customer.customer_mb_no} onChange={this.handleChange.bind(this, 'customer_mb_no')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <DatePicker fullWidth value={this.state.customer.subcription_date ? moment(this.state.customer.subcription_date) : moment()}
                                                onChange={this.handleChange.bind(this, 'subcription_date')}
                                                animateYearScrolling={false} label="Subscription Date"
                                                format="DD/MM/YYYY"
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                        </div>
                                        <h4 className="col-md-12">Address</h4><hr />
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="street_name" label="Street Name"
                                                validators={[regData.regexExp,regData.regexExpLength]}
                                                errorMessages={[regData.messageRegexEx,regData.messageLength]}
                                                // validators={['required']}
                                                // errorMessages={['This field is required']}
                                                value={this.state.customer.street_name} onChange={this.handleChange.bind(this, 'street_name')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="po_box_no" label="P.O Box Number"
                                                validators={[regData.regexExp,regData.regexExpLength]}
                                                errorMessages={[regData.messageRegexEx,regData.messageLength]}
                                                value={this.state.customer.po_box_no} onChange={this.handleChange.bind(this, 'po_box_no')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="city" label="City"
                                                validators={[regData.regexExp,regData.regexExpLength]}
                                                errorMessages={[regData.messageRegexEx,regData.messageLength]}
                                                // validators={['required']}
                                                // errorMessages={['This field is required']}
                                                value={this.state.customer.city} onChange={this.handleChange.bind(this, 'city')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="country" label="Country"
                                                // validators={['required']}
                                                // errorMessages={['This field is required']}
                                                validators={['required',regData.regexAlphaNumeric,regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                                value={this.state.customer.country} onChange={this.handleChange.bind(this, 'country')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="remarks" label="Remarks" multiline={true}
                                                validators={[regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                                errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                value={this.state.customer.remarks} onChange={this.handleChange.bind(this, 'remarks')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-12"
                                                name="path" label="Folder Path"
                                                // validators={['required']}
                                                // errorMessages={['This field is required']}
                                                validators={['required',regData.getCustomExpression('_:/'),regData.getCustomExpressionLength('_:/',0,100)]} 
                                                errorMessages={['This field is required',regData.getCustomExpMessage('_:/ '),regData.messageLength]} placeholder="D://foldername"
                                                value={this.state.customer.path} onChange={this.handleChange.bind(this, 'path')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <input type="file" name="logo" className="mt-0 mb-4 col-12"
                                                value={this.state.customer.logo} onChange={this.handleChange.bind(this, 'logo')} />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="col-12">
                                {this.state.id ? null : <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>}
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={()=>{this.props.history.push('/customer/customer-list')}}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { addCustomer, getCustomer } = state;
    const { match } = ownProps
    return { match, addCustomer, getData: getCustomer, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, getCustomer, addCustomer), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddCustomer));



// WEBPACK FOOTER //
// ./app/customerdetails/addcustomer/index.js